import React, { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Row,
  Skeleton,
  Checkbox,
  Affix,
  message,
  Tooltip,
} from 'antd'
import { ShoppingCartOutlined } from '@ant-design/icons'
import { useDispatch } from 'react-redux'
import { compareDateTimeWithNow, searchAuctionRows } from 'utils'
import { useHistory } from 'react-router-dom'
import { useAuthSelector } from 'store/authSlice/authReducer'
import { downloadQRCodePDF } from 'store/authSlice/authActions'
// import { convertFile } from 'store/reportSlice/reportActions'
import { awsconfig, config } from 'configs'
import { getAuctionBySubscriber } from 'store/auctionSlice/auctionActions'
import {
  auctionActions,
  useAuctionSelector,
} from 'store/auctionSlice/auctionReducer'
import sample from 'assets/images/sample/sample1.png'
import { Can } from 'permissions'

const MyAuction = ({ searchText, sortKey }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { organization } = useAuthSelector()
  const [selectedIds, setSelectedIds] = useState([])

  const { loading, auctions } = useAuctionSelector()
  useEffect(() => {
    dispatch(getAuctionBySubscriber(sortKey, organization?.id))
    // eslint-disable-next-line
  }, [dispatch, sortKey])

  const handleAuctionSelected = (e, auction) => {
    e.preventDefault()
    e.stopPropagation()
    dispatch(auctionActions.setAuction(null))
    history.push(`auction/${auction.Id}`)
  }

  const goToEdit = (e, auction) => {
    e.preventDefault()
    e.stopPropagation()
    history.push(`/settings/create-auction/${auction?.Id}`)
  }

  const myauction = auctions.filter(
    (item) => item?.OrganizationId === organization?.id,
  )

  const onCheckboxChange = (auctionId) => {
    const isAlreadyPresent = selectedIds.find((id) => id === auctionId)
    if (isAlreadyPresent) {
      const updatedIds = selectedIds.filter((id) => id !== auctionId)
      setSelectedIds(updatedIds)
    } else {
      setSelectedIds([...selectedIds, auctionId])
    }
  }

  const type = 'aution'
  const onPrintClick = async () => {
    message.loading('Generating QR code')
    const eventsForPrint = selectedIds.map((item) => ({
      id: item,
      name: auctions.find((element) => element?.Id === item)?.Title,
      description: auctions.find((element) => element?.Id === item)?.Details,
      url: `${window.location.origin}/auction/${item}`,
    }))
    const payload = {
      data: eventsForPrint,
      component: 'Auctions',
      Organization: organization.Name,
      logo: awsconfig.bucketUrl + organization.Logo?.fileName,
    }
    try {
      await downloadQRCodePDF(payload, dispatch)
      message.success('QR code generated!')
      // history.push(`/download/${type}`)
      window.open(`${window.location.origin}/download/${type}`, '_blank')
    } catch (error) {
      console.error('Error generating QR code:', error)
      message.error('Failed to generate QR code. Please try again.')
    }
  }

  const goToJoinScreen = (e, auction) => {
    e.preventDefault()
    e.stopPropagation()
    dispatch(auctionActions.setAuction(auction))
    history.push(`/auction/${auction?.Id}/join-auction`)
  }

  const goToControlScreen = (e, auction) => {
    e.preventDefault()
    e.stopPropagation()
    dispatch(auctionActions.setAuction(auction))
    history.push(`/auction/${auction?.Id}/control-screen`)
  }

  return (
    <Skeleton loading={loading} active paragraph={{ rows: 18 }}>
      <div className="t-flex t-flex-col t-justify-between t-h-full">
        {selectedIds.length > 0 && (
          <Row className="t-w-full t-flex t-justify-end t-p-0 md:t-p-1 -t-mt-6 md:-t-mt-8 t-mb-2 md:t-mb-2">
            <Affix offsetTop={75}>
              <Button
                type="primary"
                shape="round"
                onClick={onPrintClick}
                size="medium"
                className="glass_bg t-text-secondary-100 hover:t-text-white"
              >
                Print QR Codes
              </Button>
            </Affix>
          </Row>
        )}

        <Row gutter={[24, 24]}>
          {searchAuctionRows(myauction, searchText).length === 0 && (
            <div className="t-h-96 t-flex t-justify-center t-items-center t-w-full">
              <div className="t-flex t-flex-col t-items-center t-space-y-2">
                <ShoppingCartOutlined
                  style={{ fontSize: '2rem' }}
                  className="t-text-secondary-100"
                />
                <p>No records found</p>
              </div>
            </div>
          )}
          {searchAuctionRows(myauction, searchText).map((item, index) => (
            <Col span={24} lg={8} className="mb-24" key={index}>
              <Card
                bordered
                hoverable
                cover={
                  <img
                    alt="example"
                    className="t-w-full t-h-48 t-object-contain t-rounded-md"
                    src={
                      item?.Flyer?.fileName
                        ? awsconfig.bucketUrl + item?.Flyer?.fileName
                        : item?.OrganizationBackgroundImage
                        ? awsconfig.bucketUrl +
                          item?.OrganizationBackgroundImage?.fileName
                        : sample
                    }
                  />
                }
                onClick={(e) => handleAuctionSelected(e, item)}
              >
                <h5 className="t-text-2xl t-text-secondary-100 t-font-bold t-truncate">
                  <Tooltip title={item?.Title}>{item?.Title}</Tooltip>
                </h5>
                <div className="t-flex t-justify-between">
                  <div className="card-tag t-font-thin t-text-secondary-100">
                    {item?.OrganizationName}
                  </div>
                </div>

                <p className="t-line-clamp-1 t-text-sm">{item?.Details}</p>
                <div className="t-mt-2 t-space-x-1 t-h-8">
                  <div
                    onClick={(e) => {
                      e.stopPropagation()
                      e.preventDefault()
                      onCheckboxChange(item?.Id)
                    }}
                  >
                    <Checkbox
                      checked={selectedIds.includes(item?.Id)}
                      className="t-font-bold t-text-secondary-100"
                    >
                      Add to QR code sheet
                    </Checkbox>
                  </div>
                </div>
                <div className="t-flex t-justify-end t-space-x-1">
                  <Can I={config.actions.edit} a={config.components.auction}>
                    <Button
                      type="primary"
                      size="small"
                      className="t-rounded-full"
                      onClick={(e) => goToEdit(e, item)}
                    >
                      Edit
                    </Button>
                  </Can>
                  {item?.OrganizationId === organization?.id && (
                    <Button
                      type="primary"
                      size="small"
                      className="t-rounded-full"
                      onClick={(e) => goToControlScreen(e, item)}
                    >
                      Control
                    </Button>
                  )}
                  {item.StartDate &&
                    compareDateTimeWithNow(item.StartDate, 'after') && (
                      <Button
                        type="primary"
                        size="small"
                        className="t-rounded-full"
                        onClick={(e) => goToJoinScreen(e, item)}
                      >
                        Join
                      </Button>
                    )}
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </Skeleton>
  )
}

export { MyAuction }
